import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-kt-sticky"]
const _hoisted_2 = {
  id: "kt_page_title",
  "data-kt-swapper": "true",
  "data-kt-swapper-mode": "prepend",
  "data-kt-swapper-parent": "{default: '#kt_content_container', lg: '#kt_header_container'}",
  class: "page-title d-flex flex-column align-items-start justify-content-center flex-wrap me-lg-2 pb-2 pb-lg-0"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  style: {"height":"31px"},
  class: "d-flex"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/media/logos/logo_sens.svg",
    alt: "logo",
    class: "img-fluid",
    style: {"margin-left":"-2rem"}
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "img-fluid",
    src: "/media/logos/logo_title_sens.svg",
    alt: "logo",
    style: {"margin-left":"-1rem"}
  })
], -1)
const _hoisted_4 = {
  key: 0,
  class: "breadcrumb fw-bold fs-base my-1"
}
const _hoisted_5 = { class: "breadcrumb-item text-muted" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Home ")
const _hoisted_7 = { class: "breadcrumb-item text-dark" }
const _hoisted_8 = { class: "d-flex d-lg-none align-items-center ms-n2 me-2" }
const _hoisted_9 = {
  class: "btn btn-icon btn-active-icon-primary",
  id: "kt_aside_toggle"
}
const _hoisted_10 = { class: "svg-icon svg-icon-2x" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "d-flex align-items-center"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Logo",
    src: "media/logos/logo-demo7.svg",
    class: "h-30px"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_KTTopbar = _resolveComponent("KTTopbar")!

  return (_openBlock(), _createElementBlock("div", {
    id: "kt_header",
    class: "header container-lg-fluid px-lg-20",
    "data-kt-sticky": _ctx.isHeaderSticky,
    "data-kt-sticky-name": "header",
    "data-kt-sticky-offset": "{default: '200px', lg: '300px'}"
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["d-flex align-items-center justify-content-between", {
        'container-fluid': _ctx.headerWidthFluid,
        'container-xxl': !_ctx.headerWidthFluid,
      }]),
      id: "kt_header_container"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        (_ctx.breadcrumbs)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
              _createElementVNode("li", _hoisted_5, [
                _createVNode(_component_router_link, {
                  to: "/inicio",
                  class: "text-muted"
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                })
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.breadcrumbs, (item, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  class: "breadcrumb-item text-dark"
                }, _toDisplayString(item), 1))
              }), 128)),
              _createElementVNode("li", _hoisted_7, _toDisplayString(_ctx.title), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("span", _hoisted_10, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/abstract/abs015.svg" })
          ])
        ]),
        _hoisted_11
      ]),
      _createVNode(_component_KTTopbar)
    ], 2)
  ], 8, _hoisted_1))
}